import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../core/i18n'
import * as constants from '../../static/constants'
import { IsDesktop, IsMobileOrTablet } from '../../utils/responsive'
import HeaderMenu from '../atoms/HeaderMenu'
import HeaderNotifications from 'components/atoms/HeaderNotifications'
import { BREAKPOINT_DESKTOP } from 'static/constants'
import { IUser } from '../../static/interfaces'
import SvgIcon from 'components/atoms/SvgIcon'

interface IWindow {
  localePath: { [key: string]: string }
  location: any
}
declare var window: IWindow

interface IProps {
  isSignedIn: boolean
  user: IUser
  agentMember?: { name: string; email: string }
  lang?: { [key: string]: string }
}

const ENTER_KEYCODE = 13

const DashboardHeader: React.FC<IProps> = props => {
  const [searchBoxIsOpen, setSearchBoxIsOpen] = React.useState(false)
  const { isSignedIn, user } = props

  const urlParams = new URLSearchParams(window.location.search)
  const defaultKeywords = urlParams.get('keywords') || ''

  const onSearchHandler = async event => {
    const currentUrlParams = new URLSearchParams(window.location.search)

    if (event.target.value) {
      currentUrlParams.set(event.target.name, event.target.value)
    } else {
      currentUrlParams.delete(event.target.name)
    }

    location.href = `/posts/search?${currentUrlParams.toString()}`
  }

  const onKeyDownHandler = event => {
    if (event.keyCode && event.keyCode === ENTER_KEYCODE) {
      onSearchHandler(event)
    }
  }

  React.useEffect(() => {
    if (props.lang) {
      window.localePath = { ...props.lang }
    }
    const wrapper = document.getElementById('header-wrapper')
    wrapper.classList.add('dashboard')
  }, [])
  const SearchBox = () => (
    <Search className="Search">
      <div className="Search_Input _keywords">
        <input
          name="keywords"
          type="text"
          placeholder={I18n.t('generic.keyword')}
          defaultValue={defaultKeywords}
          onBlur={onSearchHandler}
          onKeyDown={onKeyDownHandler}
        />
        <SvgIcon name="search" className="icon" ariaHidden={true} role="presentation" />
      </div>
    </Search>
  )

  const showSearchBox = !user || user.guest || user.guide

  return (
    <HeaderWrapper className="Header">
      <div className="Header_Inner">
        <IsDesktop>
          <LogoWrapper href="/">
            <img src="/images/logo.svg" />
          </LogoWrapper>
          {showSearchBox && <SearchBox />}
          <HeaderNotifications unreadNotifications={props.user.unread_notifications_count} />
          <HeaderMenu
            user={props.user}
            agentMember={props.agentMember}
            lang={props.lang}
            isSignedIn={isSignedIn}
            desktop={true}
            fromDashboardHeader={true}
          />
        </IsDesktop>
        <IsMobileOrTablet>
          {searchBoxIsOpen && <SearchBox />}
          {showSearchBox && (
            <div className="SearchToggle" onClick={() => setSearchBoxIsOpen(old => !old)}>
              <SvgIcon name={searchBoxIsOpen ? 'close' : 'search'} className="icon" />
            </div>
          )}
          <HeaderNotifications unreadNotifications={props.user.unread_notifications_count} />

          <HeaderMenu
            fromDashboardHeader={true}
            user={props.user}
            agentMember={props.agentMember}
            lang={props.lang}
            isSignedIn={isSignedIn}
            mobile={true}
          />
        </IsMobileOrTablet>
      </div>
    </HeaderWrapper>
  )
}

const LogoWrapper = styled.a`
  display: block;
  margin-right: auto;
  img {
    width: 240px;
    height: auto;
  }
  @media (max-width: ${BREAKPOINT_DESKTOP}px) {
    display: none;
  }
`

const Search = styled.div`
  display: flex;
  position: relative;
  width: 50%;
  .Search_Input {
    position: relative;
    background: ${constants.COLORS.white};
    box-shadow: ${constants.COLORS.cardShadow};
    border-radius: 20px;
    width: 80%;

    > .icon {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 8px;
      margin: auto;
      width: 20px;
      height: 20px;
    }

    > input {
      display: block;
      width: 100%;
      height: 40px;
      padding: 10px 14px 10px 36px;
      font-size: 15px;
      transition: border 0.2s ease;
      outline: none;
      background: none;
      border: none;

      &::placeholder {
        color: #babdbf;
      }
    }
    margin-left: 24px;
  }
`

const HeaderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: ${constants.MOBILE_HEADER_HEIGHT}px;
  background: ${constants.COLORS.background};
  padding: 0 40px;
  z-index: 5000;
  @media (max-width: ${constants.BREAKPOINT_DESKTOP}px) {
    padding: 0;
    width: 100%;
  }
  @media (max-width: ${constants.BREAKPOINT_DESKTOP_XL}px) {
    height: 55px;
    padding: 0 20px;
  }

  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL - 1}px) {
    padding: 0;
  }
  .Header_Inner {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    max-width: 1340px;
    margin: 0 auto;
  }
  .SearchToggle {
    width: 24px;
    height: 24px;
    margin-right: 12px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    .icon {
      width: 24px;
      height: 24px;
    }
  }
`

export default DashboardHeader
